import TreeSelectorComponent from '@/components/commons/tree-selector/TreeSelectorComponent.vue'


export default {
    name: 'EventTypeDialogEnterpriseTabComponent',
    components: {
        TreeSelectorComponent
    },
    model: {
        prop: 'model',
        event: 'change'
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        validForm:{
            type: Boolean,
            required: true
        },
    },
    data: () => ({
        // model para el formulario
        isValidForm: false,
    }),
    computed: {
    },
    created () {
    },
    mounted () {
    },
    methods: {
        selectorMapper(node) {
            return {
                id: node._id,
                label: node.name
            }
        },
        updateSelected(enterprises) {
            this.model.enterprises = enterprises;
        }
    },
    watch: {
        /**
         * Actualizo el valor de la prop
         * @param {*} newVal
         * @param {*} oldVal
         */
        isValidForm(newVal, oldVal){
            if(newVal!==oldVal){
                this.$emit('update:validForm', newVal)
            }
        },
        'model.enterprises': {
            deep: true,
            immediate: true,
            handler: function () {
                this.isValidForm = this.model.global || (this.model.enterprises && this.model.enterprises.length > 0) ? true : false
            }
        },
        'model.global': {
            deep: true,
            immediate: true,
            handler: function () {
                this.isValidForm = this.model.global || (this.model.enterprises && this.model.enterprises.length > 0) ? true : false
            }
        }
    }
}
